import { Router } from 'react-router-dom';
import DeliRoutes from './pages/routes';
import AppConfig from '@components/app-config';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';
import { theme, deliHistory } from '@global';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import { ThemeProvider } from 'styled-components';

export default function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Router history={deliHistory}>
          <SnackbarProvider autoHideDuration={3000}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <AppConfig.Provider>
                <DeliRoutes />
              </AppConfig.Provider>
            </MuiPickersUtilsProvider>
          </SnackbarProvider>
        </Router>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}
